export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(10.5, 0.5)`)
      .style('font-family', 'roboto').attr('cursor', 'default')


      this.init_dataSetValues()
      this.draw_Menus()
      this.draw_Title()
      this.draw_Chart()

      if(this.table.visible == 'Y') {
        this.draw_Header()
        this.draw_Table()
      }

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}